import { render, staticRenderFns } from "./TokenManagementView.vue?vue&type=template&id=cb401b96&scoped=true&lang=pug"
import script from "./TokenManagementView.vue?vue&type=script&lang=ts"
export * from "./TokenManagementView.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementView.vue?vue&type=style&index=0&id=cb401b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb401b96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
